import { render, staticRenderFns } from "./PartnerForgotPassword.vue?vue&type=template&id=291c1850&"
import script from "./PartnerForgotPassword.vue?vue&type=script&lang=js&"
export * from "./PartnerForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports